import styles from './PageLoad.module.css';

const PendingLogin = () => {
  return (
    <div className={styles.Container}>
      <div className={styles.Content}>
        <div>
          <div className={styles.Loader}></div>
          <h2>Loading</h2>
        </div>
      </div>
    </div>
  );
};

export default PendingLogin;
